import type { RegexPattern } from '../types';

/**
 * @group Constants
 * @summary <blockquote>Regex patterns for template processing and placeholder replacement.</blockquote>
 * 
 * Patterns used for template variable detection, replacement, and validation.
 */
export const TEMPLATE_PROCESSING_PATTERNS = {
  /**
   * Matches unreplaced template variables like {{VARIABLE_NAME}}
   * Used to detect incomplete template rendering
   */
  UNREPLACED_VARIABLE: {
    regex: /\{\{[A-Z0-9_]+\}\}/g,
    description: 'Matches unreplaced template variables like {{VARIABLE_NAME}}',
    examples: ['{{NAME}}', '{{USER_ID}}', '{{API_KEY}}'],
    counterExamples: ['{{ NAME }}', '{{name}}', '{NAME}', 'NAME'],
  } as RegexPattern,

  /**
   * Matches regex special characters that need escaping
   * Used when building dynamic regex patterns from user input
   */
  REGEX_SPECIAL_CHARS: {
    regex: /[.*+?^${}()|[\]\\]/g,
    description: 'Matches regex special characters that need escaping',
    examples: ['.', '*', '+', '?', '^', '$', '{', '}', '(', ')', '|', '[', ']', '\\'],
    counterExamples: ['a', 'b', 'c', '1', '2', '3'],
  } as RegexPattern,

  /**
   * Matches template placeholder boundaries
   * Used to extract variable names from {{VARIABLE}} syntax
   */
  TEMPLATE_PLACEHOLDER_BOUNDARY: {
    regex: /\{\{([A-Z0-9_]+)\}\}/g,
    description: 'Matches template placeholder boundaries to extract variable names',
    examples: ['{{NAME}}', '{{USER_ID}}', '{{API_KEY}}'],
    counterExamples: ['{{ NAME }}', '{{name}}', '{NAME}', 'NAME'],
  } as RegexPattern,
} as const;
